import { Pipe, PipeTransform } from "@angular/core";
import { sprintf } from "sprintf-js";

@Pipe({
  name: "thaiDate"
})
export class ThaiDatePipe implements PipeTransform {
  transform(date: string, format: string, type: string): string {
    let ThaiDay = [
      "อาทิตย์",
      "จันทร์",
      "อังคาร",
      "พุธ",
      "พฤหัสบดี",
      "ศุกร์",
      "เสาร์"
    ];
    let shortThaiMonth = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค."
    ];
    let longThaiMonth = [
      "มกราคม",
      "กุมภาพันธ์",
      "มีนาคม",
      "เมษายน",
      "พฤษภาคม",
      "มิถุนายน",
      "กรกฎาคม",
      "สิงหาคม",
      "กันยายน",
      "ตุลาคม",
      "พฤศจิกายน",
      "ธันวาคม"
    ];
    // alert(date.replace(/-/g, '/'));
    let inputDate = new Date(date.replace(/-/g, '/'));
    if (type == "time") {
      let dd = "2019-08-08 " + date;
      inputDate = new Date(dd.replace(/-/g, '/'));
    }

    //  inputDate = new Date(date);
    if (Number.isNaN(inputDate.getMonth())) {
      let t = date.split(/[- : T]/);
      inputDate = new Date(
        parseInt(t[0]),
        parseInt(t[1]) - 1,
        parseInt(t[2]),
        parseInt(t[3]),
        parseInt(t[4]),
        parseInt(t[5])
      );
    }




    let dataDate = [
      inputDate.getDay(),
      inputDate.getDate(),
      inputDate.getMonth(),
      inputDate.getFullYear(),
      sprintf("%02d", inputDate.getHours()),
      sprintf("%02d", inputDate.getMinutes()),
      sprintf("%02d", inputDate.getSeconds())
    ];
    // alert(inputDate.getDay());

    let outputDateFull = [
      "วัน " + ThaiDay[dataDate[0]],
      "ที่ " + dataDate[1],
      "เดือน " + longThaiMonth[dataDate[2]],
      "พ.ศ. " + (parseInt(dataDate[3].toString()) + 543)
    ];

    let outputDateD = [
      dataDate[1]
    ];

    let outputDateM = [
      longThaiMonth[dataDate[2]]
    ];

    let outputDateY = [
      (parseInt(dataDate[3].toString()) + 543)
    ];


    let outputDateShort = [
      dataDate[1],
      shortThaiMonth[dataDate[2]],
      parseInt(dataDate[3].toString()) + 543
    ];
    let outputDateYM = [
      shortThaiMonth[dataDate[2]],
      parseInt(dataDate[3].toString()) + 543
    ];
    let outputDateMedium = [
      dataDate[1],
      longThaiMonth[dataDate[2]],
      parseInt(dataDate[3].toString()) + 543
    ];

    let outputDateDDMM = [
      dataDate[1],
      shortThaiMonth[dataDate[2]]
    ];

    let outputDateshort = [
      dataDate[1], "/" + shortThaiMonth[dataDate[2]], "/" + (parseInt(dataDate[3].toString()) + 543)
    ];

    let outputDateFullTime = [
      "วัน " + ThaiDay[dataDate[0]],
      "ที่ " + dataDate[1],
      "เดือน " + longThaiMonth[dataDate[2]],
      "พ.ศ. " + (parseInt(dataDate[3].toString()) + 543),
      "เวลา " + dataDate[4] + ":" + dataDate[5] + ":" + dataDate[6]
    ];
    let outputDateShortTime = [
      dataDate[1],
      shortThaiMonth[dataDate[2]],
      parseInt(dataDate[3].toString()) + 543,
      dataDate[4] + ":" + dataDate[5] + ":" + dataDate[6]
    ];
    let outputDateMediumTime = [
      dataDate[1],
      longThaiMonth[dataDate[2]],
      parseInt(dataDate[3].toString()) + 543,
      'เวลา', dataDate[4] + ":" + dataDate[5]
    ];
    let outputFullTime = [
      dataDate[4] + ":" + dataDate[5] + ":" + dataDate[6]
    ];


    let outputTimeSort = [dataDate[4] + ":" + dataDate[5]];

    let returnDate: string;
    returnDate = outputDateMedium.join(" ");
    if (format == "full") {
      returnDate = outputDateFull.join(" ");
    }
    if (format == "medium") {
      returnDate = outputDateMedium.join(" ");
    }
    if (format == "short") {
      returnDate = outputDateShort.join(" ");
    }
    if (format == "YM") {
      returnDate = outputDateYM.join(" ");
    }
    if (format == "DM") {
      returnDate = outputDateDDMM.join(" ");
    }
    if (format == "fullTime") {
      returnDate = outputDateFullTime.join(" ");
    }
    if (format == "mediumTime") {
      returnDate = outputDateMediumTime.join(" ");
    }
    if (format == "shortTime") {
      returnDate = outputDateShortTime.join(" ");
    }
    if (format == "H:i") {
      returnDate = outputTimeSort.join(" ");
    }
    if (format == "H:i:s") {
      returnDate = outputFullTime.join(" ");
    }
    if (format == "d/m/y") {
      returnDate = outputDateshort.join(" ");
    }
    if (format == "d") {
      returnDate = outputDateD.join(" ");
    }
    if (format == "m") {
      returnDate = outputDateM.join(" ");
    }
    if (format == "y") {
      returnDate = outputDateY.join(" ");
    }
    return returnDate;
  }
}
